var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#EF2929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C13.8813 12.5 15 11.3813 15 10C15 8.61875 13.8813 7.5 12.5 7.5C11.1187 7.5 10 8.61875 10 10C10 11.3813 11.1187 12.5 12.5 12.5ZM12.5 13.75C10.8312 13.75 7.5 14.5875 7.5 16.25V17.5H17.5V16.25C17.5 14.5875 14.1688 13.75 12.5 13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0195a04ddef9bc7cc73dc40219fc8672.svg";
export { ForwardRef as ReactComponent };